import { kebabCase } from 'utils/stringHelpers';
import { ProgressBar } from './ProgressBar';

export const DeliveriesProgressBarChart = ({ data }) => {
  return (
    <div data-test={`metric-bar-${kebabCase(data.name)}`} key={data.name}>
      <ProgressBar data={data.progressData} />
    </div>
  );
};
